import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'
import PosterCdnCheck from '../../CreateListmoviespersons/PosterCdnCheck'
import MovieAutoSuggestionsdata from '../../Movie/movieSearchAutosuggestion'

function SearchPerson({ fetchPersonData }) {
  // State variables initialization
  const [editPersonPrimarykey, setEditPersonPrimarykey] = useState('')
  const [autoSuggestions, setAutoSuggestions] = useState([])
  const [disabled, setDisabled] = useState(true)
  const history = useHistory()

  // Function to fetch auto suggestions based on input value
  const getSuggestions = async value => {
    setEditPersonPrimarykey(value)
    try {
      if (value === '') {
        setAutoSuggestions([])
        setDisabled(true)
      } else {
        const input = {
          search: value,
          type: 'person',
          limit: 100,
          from: 0,
        }
        const { personHits } = await MovieAutoSuggestionsdata(input)
        setDisabled(true)
        setAutoSuggestions(personHits || [])
      }
    } catch (error) {
      console.error(error)
    }
  }

  // Function to set selected suggestion as input value
  const editPersonPrimarykeyInput = suggestion => {
    setDisabled(false)
    setEditPersonPrimarykey(suggestion.PK)
    setAutoSuggestions([])
  }

  // Function to navigate to edit person page and fetch updated data
  const renderEditForm = () => {
    history.push(`/editperson?${editPersonPrimarykey}`)
    fetchPersonData()
  }

  // JSX rendering
  return (
    <Row>
      <Col md={6} xs={12}>
        <div className='search-person-container'>
          {/* Input for person ID */}
          <label className='search-label'>Person ID</label>
          <input
            type='text'
            className='form-control search-input'
            value={editPersonPrimarykey}
            placeholder='Please enter PK value'
            onChange={event => getSuggestions(event.target.value)}
          />
          {/* Render auto suggestions */}
          {autoSuggestions.length > 0 && (
            <div className='suggestions-container'>
              {autoSuggestions.map((suggestion, index) => (
                <div key={index} onClick={() => editPersonPrimarykeyInput(suggestion)}>
                  <ul className='list-group list-group-flush mb-1'>
                    {suggestion.name_En && (
                      <li className='list-group-item'>
                        <div className='media d-flex justify-content-center align-items-center'>
                          {/* Display suggestion image and name */}
                          <img
                            className='rounded-circle mr-3 suggestion-image'
                            src={PosterCdnCheck(suggestion.posterURL || '')}
                            alt={suggestion.name_En}
                          />
                          <div className='media-body align-self-center'>
                            <label>{suggestion.name_En}</label>
                          </div>
                        </div>
                      </li>
                    )}
                  </ul>
                </div>
              ))}
            </div>
          )}
          {/* Display error message if person ID is empty */}
          {disabled && <span className='mandatory1'>Person ID should not be empty</span>}
          {/* Button to trigger edit form */}
          <button
            type='button'
            disabled={disabled}
            className='btn btn-primary edit-button'
            onClick={renderEditForm}
          >
            Edit Person
          </button>
        </div>
      </Col>
    </Row>
  )
}

export default SearchPerson
